
import React, { Component } from 'react'
import Navbar from '../Navbar'
import { Badge, Alert, Row, Col, Card, Button, CardHeader, CardBody, Input, Collapse, Spinner, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';

const { proxy } = require('../../ip_api.config')

class Flim_ManageProductImage extends Component {

    constructor(props) {
        super(props)
        this.state = {
            files: {},
            uploadContent: [],
            itemId: '',
            deleteList: [],
            customAlert: {
                open: false,
                messages: '',
                status: ''
            }
        }
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const itemIdParam = urlParams.get('itemId');
        const idParam = urlParams.get('id');
        if (urlParams && itemIdParam && idParam) {
            let q = JSON.parse(window.atob(idParam))
            let q2 = JSON.parse(window.atob(itemIdParam))
            this.setState({ itemId: q2 })
            this.get_productDataById({ itemId: q, itemDesc: '', iBrand1: '', iBrand2: '', iBrand3: '', itemG1: '', itemG3: '' })
            this.get_uploadByItem({ itemId: q2, userId: localStorage.getItem("ID_User") })
        }

        let departmentRole = localStorage.getItem("DepartmentNo");
        if (departmentRole != 'D11') {
            this.props.history.push({
                pathname: '/Flim/ProductInfoTable'
            })
        }
    }

    get_uploadByItem = (data) => {
        let url = proxy.server + '/flim/getUploadByItem'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson)
                switch (responseJson.status) {
                    case 200:
                        let files = {};
                        let collapseUploadList = [];
                        responseJson.result.forEach(item => {
                            collapseUploadList.push(false)
                            files[`${item.fieldName}`] = []

                            item.dataCount = 0;

                            switch (item.inputType) {
                                case 'text':
                                    files[`${item.fieldName}`].push({ fileId: '', value: '', type: 'LINK', typeNo: item.typeNo, oldValue: '', addBy: '', remark: '', oldRemark: '' });
                                    break;
                                case 'textarea':
                                    files[`${item.fieldName}`].push({ fileId: '', value: '', type: 'TEXT', typeNo: item.typeNo, oldValue: '', addBy: '' });
                                    break;
                            }

                        });
                        this.setState({ uploadContent: responseJson.result, files: files, collapseUploadList: collapseUploadList })
                        this.get_dataUploadedByItem(data)
                        break;
                    default: this.setState({ uploadContent: [] })
                }
            })
    }

    get_productDataById = (searchData) => {
        let url = proxy.server + '/flim/getProductData'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(searchData)
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productData]", responseJson)
                switch (responseJson.status) {
                    case 200:
                        this.setState({ productData: responseJson.result })
                        break;
                    default: this.setState({ productData: [] })
                }
            })
    }

    get_dataUploadedByItem = (data) => {
        let url = proxy.server + '/flim/getDataUploadedByItem'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_dataUploadedByItem]", responseJson)
                switch (responseJson.status) {
                    case 200:
                        const { files } = this.state;
                        let filesCopy = files;
                        responseJson.result.forEach(item => {
                            for (let key in filesCopy) {
                                if (key === item.fieldName) {
                                    switch (item.inputType) {
                                        case 'file':
                                            item.fileName = item.value.substring((item.value.lastIndexOf('/') + 1));
                                            filesCopy[`${item.fieldName}`].push(item)
                                            break;
                                        case 'text':
                                            if (filesCopy[`${item.fieldName}`][0] && filesCopy[`${item.fieldName}`][0].value === '') {
                                                filesCopy[`${item.fieldName}`] = [
                                                    { fileId: item.fileId, value: item.value, type: 'LINK', typeNo: item.typeNo, oldValue: item.value, addBy: item.addBy, remark: item.remark, oldRemark: item.remark }
                                                ]
                                            } else {
                                                filesCopy[`${item.fieldName}`].push(
                                                    { fileId: item.fileId, value: item.value, type: 'LINK', typeNo: item.typeNo, oldValue: item.value, addBy: item.addBy, remark: item.remark, oldRemark: item.remark }
                                                )
                                            }
                                            break;
                                        case 'textarea':
                                            if (filesCopy[`${item.fieldName}`][0] && filesCopy[`${item.fieldName}`][0].value === '') {
                                                filesCopy[`${item.fieldName}`] = [
                                                    { fileId: item.fileId, value: item.value, type: 'TEXT', typeNo: item.typeNo, oldValue: item.value, addBy: item.addBy }
                                                ]
                                            }
                                            break;
                                    }
                                    // set dataCount for each item
                                    let uploadContent = this.state.uploadContent.slice();
                                    for (let i = 0; i < uploadContent.length; i++) {
                                        if (item.typeNo === uploadContent[i].typeNo) {
                                            uploadContent[i].dataCount++;
                                        }
                                    }
                                }
                            }
                        });
                        this.setState({ files: filesCopy }, () => {
                            console.log('object filesCopy', this.state.files)
                        })
                        break;
                    default:
                }
            })
    }


    deleteFileByItem = (isNotAddData) => {
        this.setCustomAlert('กำลังประมวลผล', 'processing')

        let url = proxy.server + '/flim/deleteUploadedDataByItem'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.deleteList,
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                switch (responseJson.status) {
                    case 200:
                        this.setState({ deleteList: [] })
                        this.setCustomAlert('บันทึกสำเร็จ', 'success')
                        //todo call service for reloading while still on page

                        isNotAddData && this.get_uploadByItem({ itemId: this.state.itemId, userId: localStorage.getItem("ID_User") })

                        break;
                    default: this.setCustomAlert('ไม่สามารถทำรายการได้ กรุณาติดต่อเจ้าหน้าที่', 'error')
                }
            })
    }


    saveDataByItem = (data) => {
        this.setCustomAlert('กำลังประมวลผล', 'processing')

        let url = proxy.server + '/flim/postProductManagement'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({ data: data, itemId: this.state.itemId })
        })
            .then(response => response.json())
            .then(responseJson => {
                switch (responseJson.status) {
                    case 200:
                        this.setCustomAlert('บันทึกสำเร็จ', 'success')

                        //todo call service for reloading while still on page
                        this.get_uploadByItem({ itemId: this.state.itemId, userId: localStorage.getItem("ID_User") })
                        this.setState({ deleteList: [] })
                        break;
                    default: this.setCustomAlert('ไม่สามารถทำรายการได้ กรุณาติดต่อเจ้าหน้าที่', 'error')
                }
            })
    }

    saveFilesByItem = (data) => {
        this.setCustomAlert('กำลังประมวลผล', 'processing')

        let url = proxy.server + '/flim/uploadProductManagement'
        fetch(url, {
            method: "POST",
            body: data
        })
            .then(response => response.json())
            .then(responseJson => {
                switch (responseJson.status) {
                    case 200:
                        // alert('Successfully Saved')
                        this.setCustomAlert('บันทึกสำเร็จ', 'success')

                        //todo call service for reloading while still on page
                        this.get_uploadByItem({ itemId: this.state.itemId, userId: localStorage.getItem("ID_User") })
                        this.setState({ deleteList: [] })
                        break;
                    default: this.setCustomAlert('ไม่สามารถทำรายการได้ กรุณาติดต่อเจ้าหน้าที่', 'error')
                }
            })
    }

    saveFileAndDataByItem = (files, data) => {
        this.setCustomAlert('กำลังประมวลผล', 'processing')

        let url = proxy.server + '/flim/postProductManagement'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({ data: data, itemId: this.state.itemId })
        })
            .then(response => response.json())
            .then(responseJson => {
                switch (responseJson.status) {
                    case 200:
                        let url2 = proxy.server + '/flim/uploadProductManagement'
                        fetch(url2, {
                            method: "POST",
                            body: files
                        })
                            .then(response2 => response2.json())
                            .then(responseJson2 => {
                                switch (responseJson2.status) {
                                    case 200:
                                        // alert('Successfully Saved')
                                        this.setCustomAlert('บันทึกสำเร็จ', 'success')

                                        //todo call service for reloading while still on page
                                        this.get_uploadByItem({ itemId: this.state.itemId, userId: localStorage.getItem("ID_User") })
                                        this.setState({ deleteList: [] })
                                        break;
                                    default: this.setCustomAlert('ไม่สามารถทำรายการได้ กรุณาติดต่อเจ้าหน้าที่', 'error')
                                }
                            })
                        break;
                    default: this.setCustomAlert('ไม่สามารถทำรายการได้ กรุณาติดต่อเจ้าหน้าที่', 'error')
                }
            })
    }

    setCustomAlert = (messages, status) => {
        this.setState({ customAlert: { open: true, messages: messages, status: status } })

        if (status !== 'processing') {
            let load
            window.clearTimeout(load);
            load = window.setTimeout(() => {
                this.setState({ customAlert: { open: false, messages: '', status: '' } })
            }, 2000)
        }
    }

    renderType = (type, name, typeNo) => {
        switch (type) {
            case 'text':
                return (
                    <React.Fragment>
                        <div className="col-md-10" style={{ padding: '0', marginBottom: '5px' }}>
                            <Button color="primary" onClick={() => this.addRowTextInput(name, typeNo)} ><i class="fa fa-plus" aria-hidden="true"></i></Button>
                        </div>
                        {
                            this.state.files[name].length > 0 &&
                            this.state.files[name].map((val, i) => {
                                return (
                                    <div style={{ display: 'flex', marginBottom: '10px' }}>
                                        {
                                            val.addBy && val.addBy.trim() === 'GROUP' ?
                                                <React.Fragment>
                                                    <div className="col-md-6 col-sm-4" id="inputRow" style={{ padding: '0' }}>
                                                        <InputGroup>
                                                            <InputGroupAddon addonType="prepend">
                                                                <InputGroupText>Link</InputGroupText>
                                                            </InputGroupAddon>
                                                            <Input type="text" name={name} value={val.value} disabled />
                                                        </InputGroup>
                                                    </div> &nbsp;
                                                    <div className="col-md-5 col-sm-4" id="inputRow" style={{ padding: '0' }}>
                                                        <InputGroup>
                                                            <InputGroupAddon addonType="prepend">
                                                                <InputGroupText>หมายเหตุ</InputGroupText>
                                                            </InputGroupAddon>
                                                            <Input type="text" name={name} value={val.remark} disabled />
                                                        </InputGroup>
                                                    </div>
                                                    <div className="col-md-1 col-sm-4" style={{ textAlign: 'end' }}>
                                                        <Button disabled><i class="fa fa-trash-o" aria-hidden="true"></i></Button>
                                                    </div>
                                                </React.Fragment>
                                                :
                                                <React.Fragment>
                                                    <div className="col-md-6 col-sm-4" id="inputRow" style={{ padding: '0' }}>
                                                        <InputGroup>
                                                            <InputGroupAddon addonType="prepend">
                                                                <InputGroupText>Link</InputGroupText>
                                                            </InputGroupAddon>
                                                            <Input invalid={false} type="text" name={name} defaultValue={val.value} value={val.value} onChange={(e) => this.handleChangeTextInput(e.target.value, i, name)} />
                                                        </InputGroup>
                                                    </div> &nbsp;
                                                    <div className="col-md-5 col-sm-4" id="inputRow" style={{ padding: '0' }}>
                                                        <InputGroup>
                                                            <InputGroupAddon addonType="prepend">
                                                                <InputGroupText>หมายเหตุ</InputGroupText>
                                                            </InputGroupAddon>
                                                            <Input invalid={false} type="text" name={name} defaultValue={val.remark} value={val.remark} onChange={(e) => this.handleChangeTextInput(e.target.value, i, name, true)} />
                                                        </InputGroup>
                                                    </div>
                                                    <div className="col-md-1 col-sm-4" style={{ textAlign: 'end' }}>
                                                        <Button color="danger" onClick={() => this.deleteRowTextInput(i, name, val.fileId)} ><i class="fa fa-trash-o" aria-hidden="true"></i></Button>
                                                    </div>
                                                </React.Fragment>
                                        }
                                    </div>
                                )
                            })
                        }
                    </React.Fragment>
                )
            case 'file':
                return (
                    <React.Fragment>
                        <input type="file" style={{ width: '104px' }} onChange={(e) => this.onUpload(name, e.target.files, e)} multiple id="file-upload" />
                        {
                            this.state.files[name] && this.state.files[name].map((val, i) => {
                                return (
                                    <div style={{ display: 'flex', margin: '5px' }} key={i}>
                                        <div style={{ flex: '1' }}>
                                            {
                                                val.type && val.type.split('/')[0] === 'image' ?
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={window.URL.createObjectURL(val)} onClick={() => this.handleDisplayImg(window.URL.createObjectURL(val))} style={{ maxHeight: '70px', maxWidth: '70px', width: '70px', height: '70px', objectFit: 'cover' }} />
                                                        <span style={{ marginLeft: '5px' }}>{val.name}</span>
                                                    </div>
                                                    : <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <span >{val.name}</span>
                                                    </div>
                                            }
                                            {
                                                val.typeName && val.typeName === 'IMAGE' ?
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={`${proxy.server}/${val.value}`} onClick={() => this.handleDisplayImg(`${proxy.server}/${val.value}`)} style={{ maxHeight: '70px', maxWidth: '70px', width: '70px', height: '70px', objectFit: 'cover' }} />
                                                        <span style={{ marginLeft: '5px' }}>{val.fileName}</span>
                                                    </div>
                                                    : val.typeName === 'FILE' && <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <span >{val.fileName}</span>
                                                    </div>
                                            }
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {
                                                val.addBy && val.addBy.trim() === 'GROUP' ?
                                                    <Button disabled >
                                                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                                                    </Button>
                                                    :
                                                    <Button color="danger" onClick={() => this.onRemoveFile(name, i, val.fileId)} >
                                                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                                                    </Button>
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </React.Fragment>
                )
            case 'textarea':
                return (
                    <React.Fragment>
                        {
                            this.state.files[name].length > 0 &&
                            this.state.files[name].map((val, i) => {
                                return (
                                    val.addBy && val.addBy.trim() === 'GROUP' ?
                                        <Input type="textarea" name={name} value={val.value} disabled />
                                        : <Input type="textarea" name={name} value={val.value} id="exampleText" onChange={(e) => this.handleChangeTextInput(e.target.value, 0, name)} />
                                )
                            })
                        }
                    </React.Fragment>
                )
        }
    }

    addRowTextInput = (name, typeNo) => {
        let filesCopy = this.state.files[name]
        filesCopy.push({ fileId: '', value: '', type: 'LINK', typeNo: typeNo, addBy: 'ITEM', remark: '' })
        this.setState({ files: { ...this.state.files, [name]: filesCopy } })
    }

    deleteRowTextInput = (index, name, fileId) => {
        const { deleteList, files } = this.state;
        let filesCopy = files[name]
        filesCopy.splice(index, 1)
        fileId !== undefined && deleteList.push(fileId)
        this.setState({ files: { ...files, [name]: filesCopy }, deleteList: deleteList })
    }

    handleChangeTextInput = (value, index, name, isLinkRemark) => {
        let filesCopy = this.state.files[name]
        if (isLinkRemark !== undefined) {
            filesCopy[index].remark = value;
        } else {
            filesCopy[index].value = value;
        }
        this.setState({ files: { ...this.state.files, [name]: filesCopy } })
    }

    onUpload = (fieldName, files, e) => {
        //there're old data inside for checking duplicated file. 
        let arr = this.state.files[fieldName];
        let checkedDuplicate = false;

        // if upload more than 0 file
        if (files.length > 0) {
            //let's check with old data
            arr.map((val, i) => {
                for (let i = 0; i < files.length; i++) {
                    // existing fileName, it will represent that it comes from DB
                    if ((val.fileName && val.fileName) === files[i].name) {
                        checkedDuplicate = true;
                        // if there's no fileName, it means it just add and not save on DB before
                    } else if ((!val.fileName && val.name) === files[i].name) {
                        checkedDuplicate = true;
                    }
                }
            })
        }

        if (checkedDuplicate) {
            alert('ขออภัยไม่สามารถอัปโหลดไฟล์ซ้ำได้')
        } else {
            for (let i = 0; i < files.length; i++) {
                arr.push(files[i])
            }
            this.setState({ ...this.state.files, [fieldName]: arr })
        }
        // clear value to reset, user can choose the same file if they delete it without saving
        e.target.value = ''
    }

    onRemoveFile = (name, index, fileId) => {
        const { files, deleteList } = this.state;
        let arr = files[name];
        // delete on UI
        arr.splice(index, 1)
        // set for delete on DB
        fileId !== undefined && deleteList.push(fileId)
        this.setState({ ...files, [name]: arr, deleteList: deleteList })
    }

    onSubmit = () => {
        // call delete function
        let mockText = [];
        let mockFile = [];
        const { files } = this.state
        let data = new FormData()
        let filesCopy = files;

        let isEmptyTextField = false

        for (let key in filesCopy) {
            let value = filesCopy[key];
            value.map(item => {
                switch (item.type) {
                    case 'LINK':
                    case 'TEXT':
                        if (item.value !== '' && item.remark !== '') {
                            if (item.fileId === '') {
                                mockText.push(item)
                            } else if (item.value !== item.oldValue || item.remark !== item.oldRemark) {
                                mockText.push(item)
                            }
                        } else {
                            if (item.fileId !== '') {
                                isEmptyTextField = true
                            }
                        }
                        break;
                    default:
                        if (!item.fileId) {
                            data.append(`${key}`, item)
                            mockFile.push("")
                        }
                }
            });
        }

        data.append("uploadContent", JSON.stringify(this.state.uploadContent))
        data.append("itemId", JSON.stringify(this.state.itemId))

        if (!isEmptyTextField) {
            this.state.deleteList.length > 0 && this.deleteFileByItem(mockFile.length === 0 && mockText.length === 0)

            if (mockFile.length > 0 && mockText.length > 0) {
                // save all type
                this.saveFileAndDataByItem(data, mockText)
            } else if (mockFile.length === 0 && mockText.length > 0) {
                this.saveDataByItem(mockText)
            } else if (mockFile.length > 0 && mockText.length === 0) {
                this.saveFilesByItem(data)
            }
        } else {
            alert('ไม่สามารถบันทึกค่าใหม่ที่เป็นค่าว่างได้ กรุณากรอกข้อมูลให้ครบถ้วน')
        }
    }

    collapseUploadList = (index) => {
        let collapseUploadList = this.state.collapseUploadList;
        collapseUploadList[index] = !collapseUploadList[index];
        this.setState({ collapseUploadList: collapseUploadList })
    }

    handleDisplayImg = (src) => {
        let modal = document.getElementById("showImg");
        let modalImg = document.getElementById("imgContent");
        modal.style.display = "block";
        modalImg.src = src;
    }

    handleCloseDisplayImg = () => {
        let modal = document.getElementById("showImg");
        modal.style.display = "none";
    }

    render() {

        const { productData } = this.state;

        return (
            <React.Fragment>
                <Navbar nav={'Flim'} menu={'Flim_ManageProductImage'} />
                <div style={{ padding: '10px' }}>
                    <Card style={{ margin: '10px' }}>
                        <CardHeader><i class="fa fa-info-circle fa-lg" aria-hidden="true"></i> ข้อมูลสินค้า</CardHeader>
                        <CardBody>
                            <div style={{ padding: '10px' }}>
                                {
                                    productData !== undefined && <ProductDetail productData={productData[0]} />
                                }
                            </div>
                        </CardBody>
                    </Card>
                    <Card style={{ margin: '10px' }}>
                        <CardHeader><i class="fa fa-cloud-upload fa-lg" aria-hidden="true"></i> รายการอัปโหลดไฟล์</CardHeader>
                        <CardBody>
                            <div style={{ padding: '10px' }}>
                                <Row>
                                    {this.state.uploadContent.map((val, i) => {
                                        return (
                                            <Card style={{ margin: '10px', width: '100%' }}>
                                                <CardHeader style={{ backgroundColor: 'rgba(0,0,0,0)', cursor: 'pointer' }} onClick={() => this.collapseUploadList(i)}>
                                                    <div style={{ display: 'flex' }} >
                                                        <span style={{ flex: '1' }}  >{val.label} <Badge color="warning">{val.dataCount > 0 && val.dataCount}</Badge></span>
                                                        <span><i class="fa fa-minus-square-o" aria-hidden="true"></i></span>
                                                    </div>
                                                </CardHeader>
                                                <Collapse isOpen={this.state.collapseUploadList[i]}>
                                                    <CardBody><Col sm="12" md="12" style={{ padding: '5px' }} key={i}>
                                                        <Row>
                                                            <Col sm="12" md="12">
                                                                {this.renderType(val.inputType, val.fieldName, val.typeNo)}
                                                            </Col>
                                                        </Row>
                                                    </Col></CardBody>
                                                </Collapse>
                                            </Card>
                                        )
                                    })}
                                </Row>
                                <Row>
                                    <Col sm="12" md="12" style={{ padding: '20px 5px 5px 5px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <div style={{ marginRight: '10px' }}  ><Button color="success" onClick={() => this.onSubmit()} ><i class="fa fa-floppy-o" aria-hidden="true"></i> SAVE</Button></div>
                                            {/* <div><Button>RESET</Button></div> */}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div id="showImg" class="modal">
                                <span class="close" onClick={() => this.handleCloseDisplayImg()} >&times;</span>
                                <img class="modal-content" id="imgContent" />
                            </div>
                            <CustomAlert open={this.state.customAlert.open} messages={this.state.customAlert.messages} status={this.state.customAlert.status} />
                        </CardBody>
                    </Card>
                </div>
            </React.Fragment>
        );
    }
}

export default Flim_ManageProductImage;

function CustomAlert(props) {
    /* status => processing, success, warning, error */
    return (
        props.open && <Alert color={props.status === 'processing' ? 'secondary' : props.status}>
            {props.status === 'processing' && <Spinner size="sm" color="secondary" />} {props.messages}
        </Alert>
    )
}

function ProductDetail(props) {
    console.log('object', props)
    return (
        <Row>
            <Col sm="6" md="6" style={{ padding: '5px' }}>
                <div style={{ display: 'flex' }}>
                    <div style={{ paddingRight: '10px', width: '20%' }} >Item Number: </div>
                    <div style={{ flex: '1' }}><Input value={props.productData.itemId} disabled /></div>
                </div>
            </Col>
            <Col sm="6" md="6" style={{ padding: '5px' }}>
                <div style={{ display: 'flex' }}>
                    <div style={{ paddingRight: '10px', width: '20%' }}>Product Name: </div>
                    <div style={{ flex: '1' }}><Input value={props.productData.itemName} disabled /></div>
                </div>
            </Col>
            <Col sm="6" md="6" style={{ padding: '5px' }}>
                <div style={{ display: 'flex' }}>
                    <div style={{ paddingRight: '10px', width: '20%' }}>IBrand 2: </div>
                    <div style={{ flex: '1' }}><Input value={props.productData.ibrand2Desc} disabled /></div>
                </div>
            </Col>
            <Col sm="6" md="6" style={{ padding: '5px' }}>
                <div style={{ display: 'flex' }}>
                    <div style={{ paddingRight: '10px', width: '20%' }}>IBrand 3: </div>
                    <div style={{ flex: '1' }}><Input value={props.productData.ibrand3Desc} disabled /></div>
                </div>
            </Col>
            <Col sm="6" md="6" style={{ padding: '5px' }}>
                <div style={{ display: 'flex' }}>
                    <div style={{ paddingRight: '10px', width: '20%' }}>Item G1: </div>
                    <div style={{ flex: '1' }}><Input value={props.productData.itemG1Desc} disabled /></div>
                </div>
            </Col>
            <Col sm="6" md="6" style={{ padding: '5px' }}>
                <div style={{ display: 'flex' }}>
                    <div style={{ paddingRight: '10px', width: '20%' }}>Item G3: </div>
                    <div style={{ flex: '1' }}><Input value={props.productData.itemG3Desc} disabled /></div>
                </div>
            </Col>
        </Row>
    )
}